<ng-ui-kit-button
  [color]="color"
  [label]="label"
  [class]="classes"
  [size]="size"
  [disabled]="disabled || loading"
  [iconAfter]="loading ? 'hourglass_top' : iconAfter"
  [type]="type"
  (onClick)="handleOnClick()">
</ng-ui-kit-button>
